import { render, staticRenderFns } from "./KT-ProjectTeam.vue?vue&type=template&id=b14524ae&scoped=true&"
import script from "./KT-ProjectTeam.vue?vue&type=script&lang=js&"
export * from "./KT-ProjectTeam.vue?vue&type=script&lang=js&"
import style0 from "./KT-ProjectTeam.vue?vue&type=style&index=0&id=b14524ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14524ae",
  null
  
)

export default component.exports